<template>
    <div id="further-options-component" v-if="!isCoordinator" >
        <pageTitle :title="this.$i18n.FURTHER_OPTIONS" />
        <div class="row">
            <div class="col-sm-12 col-md-4">
                <div class="card" id="download-excel-export-card" @click="downloadExcelExport()">
                    <div class="row">
                        <div class="col-3" style="text-align: center;">
                            <download id="km-download-icon" :size="40" v-if="!excelExportDownloading" />
                            <b-spinner variant="primary" v-else />
                        </div>
                        <div class="col-9">
                            <h6>{{ this.$i18n.EXPORT_RAW_DATA_TO_EXCEL }}</h6>
                            <small style="word-break: break-word;">
                                {{ this.$i18n.EXPORT_RAW_DATA_TO_EXCEL_DESCRIPTION }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="col-sm-12 col-md-4"
                v-if="type === 'tumour' && kmTabActive"
            >
                <div class="card no-gutters" id="download-km-export-card" @click="downloadKaplanMeierDataAsExcel()">
                    <div class="row">
                        <div class="col-3" style="text-align: center;">
                            <download id="km-download-icon" :size="40" v-if="!kmDownloading" />
                            <b-spinner variant="primary" v-else />
                        </div>
                        <div class="col-9">
                            <h6>{{ this.$i18n.EXPORT_KM_DATA_TO_EXCEL }}</h6>
                            <small style="word-break: break-word;">
                                {{ this.$i18n.EXPORT_KM_DATA_TO_EXCEL_DESCRIPTION }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { isContextValid } from "../../helpers";
import pageTitle from "../common/page-title.vue";
import Download from "vue-material-design-icons/Download.vue";
import { BSpinner } from "bootstrap-vue";

export default {
    data() {
        return {
            kmDownloading: false,
            excelExportDownloading: false,
            type: sessionStorage.evaluationsType,
        };
    },
    components: {
        pageTitle,
        Download,
        BSpinner,
    },
    computed: {
        ...mapState({
            advancedQueryCriteria: (state) => state.advancedQueryCriteria,
            isCoordinator: (state) => state.isCoordinator
        }),
        ...mapState("kaplanMeierModule", {
            kaplanMeierParameter: (state) => state.kaplanMeierParameter,
            kmTabActive: (state) => state.kmTabActive
        }),
        ...mapState("contextModule", { context: (state) => state.context })
    },
    methods: {
        ...mapActions("kaplanMeierModule", ["getExcelExport", "readKaplanMeierEstimatesAsExcelFile"]),
        downloadExcelExport() {
            this.excelExportDownloading = true;
            this.getExcelExport(this.context)
                .then((res) => {
                    this.excelExportDownloading = false;
                })
                .catch((res) => {
                    this.excelExportDownloading = false;
                });
        },
        downloadKaplanMeierDataAsExcel() {
            if (isContextValid(this.context)) {
                this.kmDownloading = true;

                var selectedContext = {
                    id: this.context.id,
                    type: this.context.type,
                };
                this.readKaplanMeierEstimatesAsExcelFile({
                    context: selectedContext,
                    kaplanMeierParameter: {},
                })
                    .catch((error) => {
                        this.isErrorWhileReadingDataOccurred = true;
                    })
                    .then((res) => {
                        this.kmDownloading = false;
                    });
            }
        },
    },
};
</script>
<style>
#further-options-component .card {
    cursor: pointer;
}
</style>
